module.exports = __webpack_public_path__ + "h5/img/banner_6.689f3d5d.jpg";